export const pages: string[] = [
  'mavzuli-test',
  'virtual',
  'dtm',
  'saqlangan-testlar',
  'natijalar',
  'top-bilimdonlar'
]